import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@staff-app/ui';
import { monthLabel, monthOptions } from '../lib/month';

interface MonthSelectProps {
  value: string;
  onChange: (month: string) => void;
  testId: string;
}

/**
 * The month picker, shared by both OptiClock pages.
 *
 * A `Select` over a generated option list, NOT `<input type="month">`. The native control is
 * used nowhere else in this repo, renders differently in every browser, and carries none of the
 * @staff-app/ui styling or the testids e2e asserts on. The options are `YYYY-MM` — exactly the
 * wire format — so nothing converts between the picker and the query.
 */
export function MonthSelect({ value, onChange, testId }: MonthSelectProps) {
  const options = monthOptions();
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-[180px]" data-testid={testId}>
        <SelectValue placeholder="Month" />
      </SelectTrigger>
      <SelectContent>
        {options.map((m) => (
          <SelectItem key={m} value={m}>
            {monthLabel(m)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
